import React from 'react';
import {Notification} from '@homeaway/react-customer-notification';
import PropTypes from 'prop-types';
import 'isomorphic-fetch';

function AppCTAModalBannerContainer(props) {
    const {
        isVrbexNative,
        systemData,
        siteFees,
        sitePrice,
        siteTaxes,
        tripEndDate,
        tripStartDate,
        userEmail,
        paymentCurrency,
    } = props;

    const optionalContext = {};
    const calculateAward = {
        siteFees: siteFees || siteFees === 0 ? siteFees.toString() : null,
        sitePrice: sitePrice || sitePrice === 0 ? sitePrice.toString() : null,
        siteTaxes: siteTaxes || siteTaxes === 0 ? siteTaxes.toString() : null,
        transactionCurrency: paymentCurrency ? paymentCurrency : null,
        tripEndDate: tripEndDate
            ? new Date(tripEndDate).toISOString().slice(0, 10)
            : null,
        tripStartDate: tripStartDate
            ? new Date(tripStartDate).toISOString().slice(0, 10)
            : null,
    };
    if (!Object.values(calculateAward).some((prop) => prop === null)) {
        optionalContext.calculateAward = calculateAward;
    }
    if (userEmail) {
        optionalContext.userEmail = userEmail;
    }

    return (
        <React.Fragment>
            <Notification
                funnelLocation={'CONFIRMATION'}
                isMobile={systemData.isMobile}
                locale={systemData.fullLocale}
                notificationLocation={'POPUP'}
                siteName={systemData.site?.name}
                isVrbexNative={isVrbexNative}
                optionalContext={optionalContext}
                isUserLoggedIn={systemData.isUserLoggedIn}
            />
        </React.Fragment>
    );
}

AppCTAModalBannerContainer.defaultProps = {
    isVrbexNative: PropTypes.bool,
    systemData: PropTypes.shape({}),
    siteFees: PropTypes.number,
    sitePrice: PropTypes.number,
    siteTaxes: PropTypes.number,
    tripEndDate: PropTypes.string,
    tripStartDate: PropTypes.string,
    userEmail: PropTypes.string,
    paymentCurrency: PropTypes.string,
};

AppCTAModalBannerContainer.defaultProps = {
    isVrbexNative: null,
    systemData: {},
    siteFees: null,
    sitePrice: null,
    siteTaxes: null,
    tripEndDate: null,
    tripStartDate: null,
    userEmail: null,
    paymentCurrency: null,
};

export default AppCTAModalBannerContainer;
